import controller from './login.controller';
import templateT1 from './templates/login-t1.view.html';
import templateAD from './templates/login-adaptative.html';

let LoginComponent = {
  template : changeTemplate,
  controller,
  bindings : {
    shCtrl : '<',
    rPass:'@'
  }
};


changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');
  if(__env.adaptative){
    return templateAD;
  } else {
    return templateT1;
  }
}

export default LoginComponent;



/** WEBPACK FOOTER **
 ** ./www/components/login/login.component.js
 **/